
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.36 17.06H6.64c-.9 0-1.64-.73-1.64-1.64V6.69c0-.9.73-1.64 1.64-1.64h8.73c.9 0 1.64.73 1.64 1.64v8.73a1.65 1.65 0 01-1.65 1.64zM15.36 31.06H6.64c-.9 0-1.64-.73-1.64-1.64v-8.73c0-.9.73-1.64 1.64-1.64h8.73c.9 0 1.64.73 1.64 1.64v8.73a1.65 1.65 0 01-1.65 1.64zM29.36 17.06h-8.73c-.9 0-1.64-.73-1.64-1.64V6.69c0-.9.73-1.64 1.64-1.64h8.73c.9 0 1.64.73 1.64 1.64v8.73c0 .91-.73 1.64-1.64 1.64z","fill":"#828791"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M29.36 31.06h-8.73c-.9 0-1.64-.73-1.64-1.64v-8.73c0-.9.73-1.64 1.64-1.64h8.73c.9 0 1.64.73 1.64 1.64v8.73c0 .91-.73 1.64-1.64 1.64z","fill":"#C7CCD5"}})])
          )
        }
      }
    